import { createContext, useContext, useEffect, useState } from "react";
import { API_CONFIG } from "../config/api";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [profileUser, setProfileUser] = useState(null); // ✅ ADDED
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const { host, fetchMe } = API_CONFIG;

    fetch(`https://${host}${fetchMe.path}`, {
      method: fetchMe.method,
      credentials: "include",
    })
      .then((res) => {
        if (!res.ok) throw new Error("Not authenticated");
        return res.json();
      })
      .then((data) => {
        if (data.authenticated) {
          setUser(data.user);
        } else {
          setUser(null);
        }
      })
      .catch(() => setUser(null))
      .finally(() => setLoading(false));
  }, []);

  const isAdmin = user?.role === "Admin";

  return (
    <AuthContext.Provider
      value={{
        user,
        setUser,
        loading,
        isAdmin,
        profileUser,      // ✅ EXPOSED
        setProfileUser,   // ✅ EXPOSED
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
